module.exports = __webpack_public_path__ + "img/pic7.ea113060.png";